'use strict';
var base = require('./base');
const Modal = require('../modalUtilities');
var banner = require('../common/bannerSlider');
let openFromBuyButton = false;

let replaceOrAddQueryParam = (url, parameter, value) => {
    var regex = new RegExp(parameter + '=[^&]+');
    var split = url.split(regex);
    if (split.length > 1) {
        return split[0] + (url.indexOf('?') > -1 ? '' : '?') + parameter + '=' + value + split[1];
    } else {
        return url + (url.indexOf('?') > -1 ? '&' : '?') + parameter + '=' + value;
    }
};

const manageApplePayButtonApperance = (response) => {
    if (response.product.readyToOrder) {
        var applePayButton = $('.js-apple-pay-btn', response.$productContainer);
        if (applePayButton.length !== 0) {
            applePayButton.attr('sku', response.product.id);
        }
        $('.js-fake-apple-pay').addClass('hidden');
        $('.js-apple-pay').removeClass('hidden');
    } else {
        $('.js-fake-apple-pay').removeClass('hidden');
        $('.js-apple-pay').addClass('hidden');
    }
};

const closeModal = (element) => {
    const modalTarget = element.dataset.target;
    $(modalTarget).removeClass('cc-open').off('click');
    $(element).removeClass('cc-pdp-background-overlay').removeClass('cc-open');
    liveChatEnable();
};

const closeSizeChartModal = () => {
    // $('#size-chart-overlay').fadeOut();
    if (window.isMobile) {
        $('.cc-product-detail .cc-info-section .cc-info-container').css('z-index', '3');
        $('.js-size-sticky').removeClass('cc-open');
        liveChatEnable();
    } else {
        var sticky = $('#js-open-from-sticky').val();
        if (sticky === 'true') {
            $('#size-modal-sticky').toggleClass('cc-open');
            $('.cc-product-detail .cc-info-section .cc-info-container').css('z-index', '3');
        } else {
            $('body').addClass('cc-blocked');
        }
    }
    var loggedCustomerEmail = $('.js-requestsize-email').data('islogged');
    var islogged = (loggedCustomerEmail !== null && loggedCustomerEmail !== 'undefined');
    if (!islogged) {
        clearForm($('.js-form-control-requestsize'));
    }
    uploadFormRequestSize();
};
const openSizeChartModal = () => {
    // $('#size-chart-overlay').show();
    if (window.isMobile) {
        var mod = $('#size-chart-overlay-mobile').find('.cc-size-guide-standard.cc-size-guide-component');
        var headerHeigth = 81;
        var totHeigth = headerHeigth;
        if ($('.cc-shipment-banner').length > 0) {
            var bannerParent = $('.cc-shipment-banner').parent('div');
            var bannerHeigth = bannerParent.height();
            totHeigth += bannerHeigth;
        }
        mod.css('padding-top', totHeigth + 'px');
    } else {
        var sticky = $('#js-open-from-sticky').val();
        if (sticky === 'true') {
            $('#size-modal-sticky').toggleClass('cc-open');
        }
    }
    $('.cc-product-detail .cc-info-section .cc-info-container').css('z-index', '10');
};

const footerElement = document.getElementsByTagName('footer')[0];
const viewportHeight = document.documentElement.clientHeight;

function uploadSuccesPage($selector, data) {
    $selector.empty().html(data.succesPageHtml);
};

function uploadFormRequestSize() {
    $('.js-form-control-requestsize').fadeIn();
    $('.js-success-page-requestSize').fadeOut();
}

function clearForm(form) {
    $(form).find('.cc-input.cc-error').removeClass('cc-error');
    $(form).find('.cc-feedback-message').children('.cc-text-message').text('');
    $(form).find('.cc-input.js-requestsize-firstName').val('');
    $(form).find('.cc-input.js-requestsize-lastName').val('');
    $(form).find('.cc-input.js-requestsize-email').val('');
    $('.js-requestsize-title').selectpicker('val', '');

    $('.alert', form).remove();
};
function setButtonAttribute() {
    $('.selectpicker').selectpicker();
    $('.selectpicker').each(function() {
        $(this).css({
            display: 'none'
        });
        var label;
        // set button id for label
        if (this.labels.length > 0) {
            label = this.labels[0].innerText;
        } else {
            label = $(this).closest('.cc-form-group').find('.cc-label').html();
        }
        var $button = $(this).siblings('button');
        // var selectID = $(this).attr('id') + '_btn';
        // var labelID = $(this).attr('id') + '_lbl';
        // $(this).attr('aria-hidden', 'true');
        // $button.attr('id', selectID);
        $button.attr('aria-label', label);
        // $button.attr('aria-labelledby', selectID + ' ' + labelID);
        $(this).selectpicker('refresh');
        // fix voice over
        $(this).parent().find('.dropdown-toggle').removeAttr('role');
    });
}
/*
function allFildeRequestSize() {
    var size, title, name, lastName, email;
    if (!window.isMobile) {
        size = $('.js-requestsize-size').find(':selected').val();
        title = $('.js-requestsize-title').find(':selected').val();
        name = $('.js-requestsize-firstName').val();
        lastName = $('.js-requestsize-lastName').val();
        email = $('.js-requestsize-email').val();
    } else {
        size = $('.cc-requestsize-only-mobile .js-requestsize-size').find(':selected').val();
        title = $('.cc-requestsize-only-mobile .js-requestsize-title').find(':selected').val();
        name = $('.cc-requestsize-only-mobile .js-requestsize-firstName').val();
        lastName = $('.cc-requestsize-only-mobile .js-requestsize-lastName').val();
        email = $('.cc-requestsize-only-mobile .js-requestsize-email').val();
    }
};
*/
function liveChatEnable() {
    $('.helpButton').css({
        display: 'block',
        visibility: 'visible'
    });
};
function liveChatDisable() {
    $('.helpButton').css({
        display: 'none',
        visibility: 'hidden'
    });
}
function liveChatPositionStikyUp() {
    var stikyHeight = $('.cc-sticky-add-to-cart').height();
    if (window.isMobile) {
        $('.helpButton').css({
            bottom: stikyHeight + 24,
            right: '16px'
        });
    } else if (window.isTablet) {
        $('.helpButton').css({
            bottom: stikyHeight + 46,
            right: '30px'
        });
    } else {
        $('.helpButton').css({
            bottom: stikyHeight + 46,
            right: '30px'
        });
    }
};

function fixLayoutForModalOpen() {
    liveChatDisable();
    $('.cc-product-detail .cc-info-section .cc-info-container').css('z-index', '10');
}

function fixLayoutForModalOpenSize() {
    $('.cc-product-detail .cc-info-section .cc-info-container').css('z-index', '10');
}

function fixLayoutForModalClose() {
    $('.cc-product-detail .cc-info-section .cc-info-container').css('z-index', '3');
    $('.js-size-sticky').removeClass('cc-open');
    var loggedCustomerEmail = $('.js-requestsize-email').data('islogged');
    var islogged = (loggedCustomerEmail !== null && loggedCustomerEmail !== 'undefined');
    if (!islogged) {
        clearForm($('.js-form-control-requestsize'));
    }
    uploadFormRequestSize();
    liveChatEnable();
}

function liveChatPositionStikyDown() {
    $('.helpButton').css({
        bottom: '16px',
        right: '16px'
    });
    if ($('.cc-pd.cc-pd-cta-anchored').length > 0) {
        $('.helpButton').css({
            bottom: '60px'
        });
    }
};

function autoSelectForOneSize() {
    // automatically preselect size if product has only one size
    var numberofsizes = $('.js-size-container').data('numberofsizes');
    if (numberofsizes && parseInt(numberofsizes) === 1
        && $('.js-size-container') && $('.js-size-container').children() && $('.js-size-container').children().first()) {
        if ($('.js-size-container').children().first().is(':disabled')) {
            var sizeCode = $('.js-size-container').children().first().data('attr-value');
            $('#js-selected-size-to-find').val(sizeCode);
        } else {
            $('.js-size-container').children().first().trigger('click');
        }
    }
};

function updateSizeList () {
    var sku = $(document).find('.cc-product-detail').data('pid');
    var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
    var url = $('.js-selectSize .js-sizeSelector-url').data('getsizeurl');
    if (!$('.js-upload-size').hasClass('js-upload-compleated')) {
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            data: {
                sku: sku,
                color: color
            },
            success: function (data) {
                for (var i = 0; i < data.checkSize.length; i++) {
                    var el = data.checkSize[i];
                    var $size = $(document).find('.js-checkSize-' + el.value);
                    var $RequestSize = $(document).find('.js-checkRequestSize-' + el.value);
                    if (el.selectable) {
                        $size.removeClass('col-6').removeClass('col-md-8').addClass('col-12');
                        $size.removeClass('cc-request-size');
                        $size.removeAttr('disabled');
                        $size.parent().removeClass('cc-request-size');
                        if (el.isOnlyOneLeft) {
                            $size.find('.js-limited-availability').removeClass('hidden');
                        }
                        $RequestSize.addClass('hidden');
                        $RequestSize.parent().addClass('hidden');
                    } else if (!el.selectable) {
                        $size.attr('disabled');
                        $size.addClass('col-6').addClass('col-md-8').removeClass('col-12');
                        $size.addClass('cc-request-size');
                        $size.parent().addClass('cc-request-size');
                        $size.find('.js-limited-availability').addClass('hidden');
                        if (!el.hideNotifyMeProduct) {
                            $RequestSize.removeClass('hidden');
                            $RequestSize.parent().removeClass('hidden');
                        }
                    } else if ($size.hasClass('col-12') && el.selectable) {
                        el.isOnlyOneLeft ? $size.find('.js-limited-availability').removeClass('hidden') : $size.find('.js-limited-availability').addClass('hidden');
                    }
                }
                $.spinner().stop();
            }
        });
    }
    $(document).find('.cc-size-list .cc-size-container').removeClass('cc-active');
    $(document).find('.cc-size-list button.cc-active').parent().addClass('cc-active');
};

function updateSizeListLook () {
    var sku = $(document).find('.js-product-single-look').data('sku');
    var color = $(document).find('.js-product-single-look').data('color');
    var url = $('.js-selectSize .js-sizeSelector-url').data('getsizeurl');
    if (!$('.js-upload-size').hasClass('js-upload-compleated')) {
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            data: {
                sku: sku,
                color: color
            },
            success: function (data) {
                for (var i = 0; i < data.checkSize.length; i++) {
                    var el = data.checkSize[i];
                    var $size = $(document).find('.js-checkSize-' + el.value);
                    var $RequestSize = $(document).find('.js-checkRequestSize-' + el.value);
                    if (el.selectable) {
                        $size.removeClass('col-6').removeClass('col-md-8').addClass('col-12');
                        $size.removeClass('cc-request-size');
                        $size.removeAttr('disabled');
                        $size.parent().removeClass('cc-request-size');
                        if (el.isOnlyOneLeft) {
                            $size.find('.js-limited-availability').removeClass('hidden');
                        }
                        $RequestSize.addClass('hidden');
                        $RequestSize.parent().addClass('hidden');
                    } else if (!el.selectable) {
                        $size.attr('disabled');
                        $size.addClass('col-6').addClass('col-md-8').removeClass('col-12');
                        $size.addClass('cc-request-size');
                        $size.parent().addClass('cc-request-size');
                        $size.find('.js-limited-availability').addClass('hidden');
                        if (!el.hideNotifyMeProduct) {
                            $RequestSize.removeClass('hidden');
                            $RequestSize.parent().removeClass('hidden');
                        }
                    } else if ($size.hasClass('col-12') && el.selectable) {
                        el.isOnlyOneLeft ? $size.find('.js-limited-availability').removeClass('hidden') : $size.find('.js-limited-availability').addClass('hidden');
                    }
                }
                $.spinner().stop();
            }
        });
    }
    $(document).find('.cc-size-list .cc-size-container').removeClass('cc-active');
    $(document).find('.cc-size-list button.cc-active').parent().addClass('cc-active');
};

/* PDP Reccomendations Slider */
function recommendationSlider () {
    var arialabelPrev = $('.cc-product-list.cc-slider').data('arialabelprev');
    var arialabelNext = $('.cc-product-list.cc-slider').data('arialabelnext');
    var arrowNext = $('.cc-product-list.cc-slider').data('arrowdx');
    var arrowPrev = $('.cc-product-list.cc-slider').data('arrowsx');
    if ($('.cc-product-list.cc-slider').length > 0) {
        if ($('.cc-product-list.cc-slider.slick-slide').length === 0) {
            $('.cc-product-list.cc-slider').each(function () {
                var slidesContainer = $(this);
                var slidesToShow = slidesContainer.data('items-row');

                slidesContainer.slick({
                    accessibility: false,
                    infinite: false,
                    autoplay: false,
                    focusOnSelect: false,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: slidesToShow,
                    variableWidth: false,
                    dots: false,
                    dotsClass: 'slick-dots-line',
                    appendDots: $('.js-product-list-slick-dots'),
                    arrow: true,
                    prevArrow: '<button class="cc-slider-prev" aria-label="' + arialabelPrev + '"><svg class="cc-icon" aria-hidden="true" focusable="false"><use xlink:href="' + arrowPrev + '"></use></svg></button>',
                    nextArrow: '<button class="cc-slider-next" aria-label="' + arialabelNext + '"><svg class="cc-icon" aria-hidden="true" focusable="false"><use xlink:href="' + arrowNext + '"></use></svg></button>',
                    responsive: [
                        {
                            breakpoint: 1439.98,
                            settings: {
                                slidesToShow: 3,
                                dots: true,
                                arrow: false
                            }
                        },
                        {
                            breakpoint: 767.98,
                            settings: {
                                slidesToShow: 1,
                                dots: false,
                                arrow: true
                            }
                        }
                    ]
                });
            });
        }
    }
};

// da chiamare dopo il caricamento
function removeWishlistinRecommendation () {
    $(document).find('.cc-product-recommendations .cc-product-tile button.js-add-to-wishlist').remove();
}

function canStickybarAppear(){
    var visibleCheckElement = document.getElementsByClassName('visible-check');
    let isAddToCartVisible = false;
    if (visibleCheckElement.length > 0) {
        isAddToCartVisible = visibleCheckElement && visibleCheckElement[0].getBoundingClientRect().bottom > 0;
    }
    let isFooterVisible = footerElement.getBoundingClientRect().top < viewportHeight;
    let isReccomendationsVisible;
    let stickyCanAppear;
    if (document.getElementsByClassName('cc-product-recommendations')
        && document.getElementsByClassName('cc-product-recommendations').length > 0
        && document.getElementsByClassName('cc-product-recommendations')[0] != null) {
        var height = document.getElementsByClassName('cc-product-recommendations')[0].getBoundingClientRect().height;
        var bottom = document.getElementsByClassName('cc-product-recommendations')[0].getBoundingClientRect().bottom;
        var top = document.getElementsByClassName('cc-product-recommendations')[0].getBoundingClientRect().top;
        var heightHeader = document.getElementsByClassName('cc-header')[0].getBoundingClientRect().height;
        var visibleUp = top > height;
        var visibleDown = bottom - heightHeader < 0;
        isReccomendationsVisible = !(visibleDown || visibleUp);
        // Check if in the current position, the sticky could appear as soon as the scroll ends || (bottom - heightHeader < 0)
        stickyCanAppear = !isAddToCartVisible && !isFooterVisible && !isReccomendationsVisible;
    } else {
        stickyCanAppear = !isAddToCartVisible && !isFooterVisible;
    }
    return stickyCanAppear;
}

module.exports = {
    availability: base.availability,

    updatePrice: function () {
        // shop by look: update price for each product
        $(function(){
            var productIds = $('.cc-product-list .product').map(function(){
                return $(this).attr('data-pid');
            }).get();

            $(document).trigger('product:updatePrices', productIds);
        });
    },

    loadVideo: function () {
        let $videoContainer = $('.js-video-container');
        if ($videoContainer.length === 0) {
            return;
        }

        let url = $videoContainer.data('video-url');
        $.ajax({
            url: url,
            success: function (data) {
                $('.js-video-iframe').attr('src', data.videoURL);
            }
        });
    },

    discoverMore: function () {
        $(document).on('click', '.js-discover-more-analytics', function(e) {
            var productName = $('.js-analytics-look-product').attr('data-name');
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Product Look Detail Page',
                eventAction: 'discover more',
                eventLabel: productName
            });
        });
    },

    fourGift: function () {
        $('body').on('4gift:openSizeSticky', function(e) {
            const modalTarget = $('.js-size-sticky').data('target');
            $('.js-size-sticky').toggleClass('cc-open');
            $(modalTarget).toggleClass('cc-open');
            liveChatDisable();
        });

        $('body').on('4gift:openSizeModal', function(e) {
            let modalTarget = $('.js-size-modal').eq(0).data('target');
            let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpenSize, onClose: fixLayoutForModalClose });
            modal.open();
            $('body').one('product:afterAttributeSelect', () => {
                modal.close();
            });
        });
    },

    changeProductLook: function() {
        $('body').on('click', '.js-select-single-tile-look', function(e) {
            e.preventDefault();
            var url = $(this).data('href');
            var pid = $(this).data('pid');
            var data = {
                pid: pid
            };

            $.ajax({
                url: url,
                data: data,
                method: 'GET',
                success: function (data) {
                    if (data.stickyBar) {
                        $('.js-sticky-look-container').html(data.stickyBar);
                    }
                    if (data.imageToChange) {
                        $('.js-image-main-look').html(data.imageToChange);
                    }
                    if (data.product) {
                        $('.js-product-name').text(data.product.microCategoryAcme);
                        $('.js-product-color').text(data.product.mainColor);
                    }
                    if (data.productLink) {
                        $('.js-link-product').attr('href', data.productLink);
                    }
                    var productName = $('.js-analytics-look-product').attr('data-name');
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'Product Look Detail Page',
                        eventAction: 'variant select',
                        eventLabel: productName
                    });
                },
                error: function(err) {
                }
            });
        });
    },

    addToCart: function () {
        $('body').on('click', 'button.add-to-cart', function (e) {
            e.stopPropagation();
            if ($(this).data('sticky')) {
                $('.js-analytics-click-product-info-' + $(this).data('pid')).attr('data-from', $(this).data('sticky'));
            } else $('.js-analytics-click-product-info-' + $(this).data('pid')).attr('data-from', 'pdp');
            if ($('.add-to-cart').data('disabled')) {
                let isInSticky = $(e.currentTarget).closest('.js-sticky').length;
                openFromBuyButton = true;
                if (isInSticky) {
                    // Close all other modals opened sticky
                    $('.js-sticky-choice').each((_idx, el) => {
                        let $el = $(el);
                        $el.removeClass('cc-open');
                        $($el.data('target')).removeClass('cc-open');
                    });
                    // open size modal sticky
                    const modalTarget = $('.js-size-sticky').data('target');
                    $('.js-size-sticky').toggleClass('cc-open');
                    $(modalTarget).toggleClass('cc-open');
                    liveChatDisable();
                } else {
                    let modalTarget = $('.js-size-modal').eq(0).data('target');
                    let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpenSize, onClose: fixLayoutForModalClose });
                    modal.open();
                    $('body').one('product:afterAttributeSelect', () => {
                        modal.close();
                    });
                    $('.js-check-availability').one('click', () => { modal.close(); });
                    $('.js-close-requestSize').one('click', () => { modal.close(); });
                }
                if ($(e.currentTarget).hasClass('js-add-to-cart-sticky-look')) {
                    updateSizeListLook();
                } else updateSizeList();

                var id = $(document).find('.cc-product-detail').data('pid');
                var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
                var analyticsOwn = 'add to cart';
                $('#size-overlay').data('analyticsowner', analyticsOwn);

                // new analytics parameter: accessType
                if ($('body.cc-mobile').length || $(this).parents('.js-sticky-add-to-cart').length) {
                    var accessType = 'pdp-sticky-bottom';
                } else {
                    var accessType = 'pdp';
                }
                $('#size-overlay').data('accessType', accessType);

                dataLayer.push({
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'open',
                    eventLabel: id + color,
                    buttonType: analyticsOwn,
                    accessType: accessType
                });
            } else {
                if ($(e.currentTarget).hasClass('js-add-to-cart-sticky-look')) {
                    updateSizeListLook();
                } else updateSizeList();
                if (!$(document).find('.js-upload-size .cc-active .js-select-size').hasClass('cc-request-size')) {
                    if ($(e.currentTarget).hasClass('js-add-to-cart-sticky-look')) {
                        base.performAddToCartLook(this);
                    } else base.performAddToCart(this);
                } else {
                    let modalTarget = $('.js-size-modal').eq(0).data('target');
                    let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
                    modal.open();
                    $('body').one('product:afterAttributeSelect', () => {
                        modal.close();
                    });
                    $('.js-check-availability').one('click', () => { modal.close(); });
                    $('.js-close-requestSize').one('click', () => { modal.close(); });
                }
            }
        });
    },

    fixStickybarHidingOnClick: function () {
        // fix stickybar hiding when clicking on color or size selector
        $('.js-sticky-add-to-cart').on('click', function (e) {
            var now = Date.now().toString();
            $(this).attr('data-recent-click', now);
            setTimeout(() => {
                if ($(this).attr('data-recent-click') === now) {
                    $(this).attr('data-recent-click', '');
                    // check if the stickybar's position is still valid
                    if (! canStickybarAppear()) {
                        // close all open subwindows
                        let $modals = $('.cc-sticky-add-to-cart').find('.js-sticky-choice').toArray();
                        $modals.forEach((el) => {
                            $(el).removeClass('cc-open');
                            $($(el).data('target')).removeClass('cc-open');
                        });
                        // hide stickybar
                        let $sticky = $('.cc-sticky-add-to-cart').not('.js-sticky-add-to-cart-look');
                        $sticky.removeClass('cc-open').addClass('cc-close');
                    }
                }
            }, 1000);
        });
    },

    openStickySelector: function () {
        // Open the size modal in PDP
        $('body').on('click', '.js-sticky-choice', function (e) {
            openFromBuyButton = false;
            $('#4giftButtonSizeNotSelected').val('false');
            $('#payPalButtonSizeNotSelected').val('false');
            e.stopPropagation();
            updateSizeList();
            let isCurrentModalOpen = $(e.currentTarget).hasClass('cc-open');
            $('.js-sticky-choice').each((_idx, el) => {
                // Close all other modals opened
                let $el = $(el);
                $el.removeClass('cc-open');
                $($el.data('target')).removeClass('cc-open');
                liveChatEnable();
            });
            let isSizeBtn = $(e.currentTarget).hasClass('js-size-sticky');
            var sku = $(e.currentTarget).closest('.product-detail').attr('data-skumaster');
            let color = $('.js-color-choice.cc-active').data('attr-value');
            var analyticsOwn = $('#size-modal-sticky').data('analyticsowner') || $('#size-overlay').data('analyticsowner');
            var accessType = $('#size-modal-sticky').data('accessType') || $('#size-overlay').data('accessType');
            if (!isCurrentModalOpen) {
                // If the modal was not open before, close it. If the modal was open before, it means
                // we are closing it, but we did it in the each loop
                let $modal = $(e.currentTarget).toggleClass('cc-open').data('target');
                $($modal).toggleClass('cc-open');
                if (isSizeBtn) {
                    if (!analyticsOwn || e.originalEvent !== undefined) {
                        analyticsOwn = 'select size';
                        $('#size-modal-sticky').data('analyticsowner', analyticsOwn);
                    }
                    if (!accessType || e.originalEvent !== undefined) {
                        accessType = 'pdp-sticky-bottom';
                        $('#size-modal-sticky').data('accessType', accessType);
                    }
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'Size Selector',
                        eventAction: 'open',
                        eventLabel: sku + color,
                        buttonType: analyticsOwn,
                        accessType: accessType
                    });
                }
            } else if (isSizeBtn) {
                dataLayer.push({
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'close',
                    eventLabel: sku + color,
                    buttonType: analyticsOwn,
                    accessType: accessType
                });
                $('#size-modal-sticky').removeData('analyticsowner');
                $('#size-overlay').removeData('analyticsowner');
                $('#size-modal-sticky').removeData('accessType');
                $('#size-overlay').removeData('accessType');
            }
        });
    },

    openStickySelectorLook: function () {
        // Open the size modal in PDP
        $('body').on('click', '.js-sticky-choice-look', function (e) {
            openFromBuyButton = false;
            $('#4giftButtonSizeNotSelected').val('false');
            $('#payPalButtonSizeNotSelected').val('false');
            e.stopPropagation();
            updateSizeListLook();
            var scrollTimer = setTimeout(() => {
                liveChatPositionStikyUp();
            }, 250);
            if ($('.cc-product-detail .cc-content-colors-choice-sticky .cc-slider').length > 0) {
                if ($('.cc-product-detail .cc-content-colors-choice-sticky .cc-slider .slick-slide').length === 0) {
                    $('.cc-product-detail .cc-content-colors-choice-sticky .cc-slider').each(function () {
                        var slidesContainer = $(this);
                        slidesContainer.slick({
                            infinite: false,
                            autoplay: false,
                            focusOnSelect: true,
                            centerMode: false,
                            autoplaySpeed: 3000,
                            speed: 500,
                            slidesToScroll: 1,
                            slidesToShow: 5,
                            variableWidth: false,
                            dots: false,
                            arrow: true,
                            prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                            nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>',
                            responsive: [
                                {
                                    breakpoint: 1199.98,
                                    settings: {
                                        slidesToShow: 12
                                    }
                                },
                                {
                                    breakpoint: 767.98,
                                    settings: {
                                        slidesToShow: 5
                                    }
                                }
                            ]
                        });
                    });
                }
            };
            let isCurrentModalOpen = $(e.currentTarget).hasClass('cc-open');
            $('.js-sticky-choice-look').each((_idx, el) => {
                // Close all other modals opened
                let $el = $(el);
                $el.removeClass('cc-open');
                $($el.data('target')).removeClass('cc-open');
                liveChatEnable();
            });
            let isSizeBtn = $(e.currentTarget).hasClass('js-size-sticky');
            var sku = $(e.currentTarget).closest('.js-product-single-look').attr('data-sku');
            var color = $(e.currentTarget).closest('.js-product-single-look').attr('data-color');
            if (!isCurrentModalOpen) {
                // If the modal was not open before, close it. If the modal was open before, it means
                // we are closing it, but we did it in the each loop
                let $modal = $(e.currentTarget).toggleClass('cc-open').data('target');
                $($modal).toggleClass('cc-open');
                if (isSizeBtn) {
                    var analyticsOwn = 'select size';
                    $('#size-modal-sticky').data('analyticsowner', analyticsOwn);
                    var accessType = 'pdp-sticky-bottom-look';
                    $('#size-modal-sticky').data('accessType', accessType);
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'Size Selector',
                        eventAction: 'open',
                        eventLabel: sku + color,
                        buttonType: analyticsOwn,
                        accessType: accessType
                    });
                }
            } else if (isSizeBtn) {
                var analyticsOwn = $('#size-modal-sticky').data('analyticsowner');
                var accessType = $('#size-modal-sticky').data('accessType');
                dataLayer.push({
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'close',
                    eventLabel: sku + color,
                    buttonType: analyticsOwn,
                    accessType: accessType
                });
                $('#size-modal-sticky').removeData('analyticsowner');
                $('#size-modal-sticky').removeData('accessType');
            }
        });
    },

    zoomElement: function () {
        var zoomCounter = 0;
        $('body').on('click keypress', '.js-zoom', function (e) {
            let imageToZoom = e.currentTarget;
            let fullResolution = imageToZoom.src;
            var sixeClass = window.width < 768 ? 'js-max' : 'js-min';
            let fullResolutionSrcSet = $(imageToZoom).closest('.cc-content-image').find('picture source.' + sixeClass)[0].srcset;
            let $zoomedImage = $('.js-zoom-modal img');
            var stickyOverlay = !$('.cc-size-choice-overlay-sticky').hasClass('cc-open') && !$('.cc-color-choice-overlay-sticky').hasClass('cc-open');
            if (stickyOverlay) {
                $.spinner().start();
                $('.js-zoom-modal').removeClass('hidden').removeClass('cc-loaded');
                $zoomedImage.addClass('hidden');
                $zoomedImage.attr('src', fullResolution);
                $zoomedImage.attr('srcset', fullResolutionSrcSet);

                if (zoomCounter > 0) {
                    $('.js-zoom-modal').removeClass('cc-loading').addClass('cc-loaded');
                    $zoomedImage.removeClass('hidden');
                    $('body').addClass('cc-blocked');
                } else {
                    zoomCounter++;
                    $zoomedImage.on('load', (e) => {
                        $('.js-zoom-modal').addClass('cc-loaded');
                        $.spinner().stop();
                        $zoomedImage.removeClass('hidden');
                        var outerContent = $('.js-zoom-modal');
                        var innerContent = $('.js-zoom-modal img');
                        $('body').addClass('cc-blocked');
                        outerContent.scrollLeft((innerContent.width() - outerContent.width()) / 2);
                        outerContent.scrollTop((innerContent.height() - outerContent.height()) / 2);
                    });
                }
            }
        });

        $('body').on('click', '.js-zoom-modal img', function (e) {
            $('.js-zoom-modal').addClass('hidden').removeClass('cc-loaded');
            $('body').removeClass('cc-blocked');
        });

        $('body').on('focusout', '.js-zoom', function (e) {
            $('.js-zoom-modal').addClass('hidden').removeClass('cc-loaded');
            $('body').removeClass('cc-blocked');
        });
    },

    positionStickyElement: function () {
        const closeAllOpenSubwindow = () => {
            let $modals = $('.cc-sticky-add-to-cart').find('.js-sticky-choice').toArray();
            $modals.forEach((el) => {
                $(el).removeClass('cc-open');
                $($(el).data('target')).removeClass('cc-open');
            });
        };
        let scrollTimer;
        $(document).on('scroll', function () {
            // Manage the fact that scroll events are extremely common: if another scroll event was registered less than 250
            // milliseconds before, we do not consider it
            if (scrollTimer) {
                clearTimeout(scrollTimer);
                liveChatPositionStikyDown();
            }
            if ($('.js-sticky-add-to-cart').attr('data-recent-click')) {
                // prevent stickybar from instantly hiding when clicking on size or color buttons.
                return;
            }
            closeAllOpenSubwindow();
            let $sticky = $('.cc-sticky-add-to-cart').not('.js-sticky-add-to-cart-look');
            // When we scroll, the sticky should be always hidden
            $sticky.removeClass('cc-open').addClass('cc-close');
            var visibleCheckElement = document.getElementsByClassName('visible-check');
            let isAddToCartVisible = false;
            if (visibleCheckElement.length > 0) {
                isAddToCartVisible = visibleCheckElement && visibleCheckElement[0].getBoundingClientRect().bottom > 0;
            }
            let isFooterVisible = footerElement.getBoundingClientRect().top < viewportHeight;
            let isReccomendationsVisible;
            let stickyCanAppear;
            if (document.getElementsByClassName('cc-product-recommendations')
                && document.getElementsByClassName('cc-product-recommendations').length > 0
                && document.getElementsByClassName('cc-product-recommendations')[0] != null) {
                var height = document.getElementsByClassName('cc-product-recommendations')[0].getBoundingClientRect().height;
                var bottom = document.getElementsByClassName('cc-product-recommendations')[0].getBoundingClientRect().bottom;
                var top = document.getElementsByClassName('cc-product-recommendations')[0].getBoundingClientRect().top;
                var heightHeader = document.getElementsByClassName('cc-header')[0].getBoundingClientRect().height;
                var visibleUp = top > height;
                var visibleDown = bottom - heightHeader < 0;
                isReccomendationsVisible = !(visibleDown || visibleUp);
                // Check if in the current position, the sticky could appear as soon as the scroll ends || (bottom - heightHeader < 0)
                stickyCanAppear = !isAddToCartVisible && !isFooterVisible && !isReccomendationsVisible;
            } else {
                stickyCanAppear = !isAddToCartVisible && !isFooterVisible;
            }

            if (stickyCanAppear) {
                scrollTimer = setTimeout(() => {
                    $sticky.addClass('cc-open').removeClass('cc-close');
                    liveChatPositionStikyUp();
                }, 250);
            }
        });

        const $stickyOverlay = $('.cc-size-choice-overlay-sticky');
        const $stickyColor = $('.cc-content-colors-choice-sticky');

        $(document).click(e => {
            if (!$stickyOverlay.is(e.target)
                && $stickyOverlay.has(e.target).length === 0
                && !$stickyColor.is(e.target) &&
                $stickyColor.has(e.target).length === 0) {
                if ($('.js-sticky-choice').hasClass('cc-open')) {
                    liveChatEnable();
                }
                closeAllOpenSubwindow();
            }
        });
    },

    openRequestSizeFromPlp: function () {
        $(document).ready(function () {
            var size = $('.js-open-requestsize-from-plp').data('requestsize');
            if (size !== null && (size !== undefined) && (size !== 'undefined')) {
                $('.cc-size-choice-overlay-sticky').find('.js-check-availability').each(function() {
                    if ($(this).data('size') === size) {
                        $(this).click();
                        return false;
                    }
                });
            }
        });
    },

    openSizeSelector: function () {
        const performOpenSizeSelector = (e) => {
            e.stopPropagation();
            let modalTarget = e.currentTarget.dataset.target;
            let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpenSize, onClose: fixLayoutForModalClose });

            updateSizeList();
            modal.open();
            $('body').one('product:afterAttributeSelect', () => {
                modal.close();
            });
            $('.js-check-availability').one('click', () => { modal.close(); });
            $('.js-close-requestSize').one('click', () => { modal.close(); });
        };
        // Open the size modal in PDP
        $('body').on('click', '.js-open-choice', (e) => {
            openFromBuyButton = false;
            $('#4giftButtonSizeNotSelected').val('false');
            $('#payPalButtonSizeNotSelected').val('false');
            performOpenSizeSelector(e);

            var colorModal = e.currentTarget.classList.contains('js-open-color-choice');

            if (!colorModal) {
                var sku = $(e.currentTarget).closest('.product-detail').attr('data-skumaster');
                let color = $('.js-color-choice.cc-active').data('attr-value');
                // new analytics parameter: accessType
                var accessType = $('#size-overlay').data('accessType');
                if (!accessType) {
                    if ($('body.cc-mobile').length || $(this).parents('.js-sticky-add-to-cart').length) {
                        accessType = 'pdp-sticky-bottom';
                    } else {
                        accessType = 'pdp';
                    }
                    $('#size-overlay').data('accessType', accessType);
                }

                var analyticsOwn = $('#size-overlay').data('analyticsowner'); // paypal insert value before open modal
                if (!analyticsOwn) {
                    analyticsOwn = 'select size';
                    $('#size-overlay').data('analyticsowner', analyticsOwn);
                }
                dataLayer.push({
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'open',
                    eventLabel: sku + color,
                    buttonType: analyticsOwn,
                    accessType: accessType
                });
            }
        });
        $('body').on('click', '.js-fake-apple-pay.js-desktop', (e) => {
            var id = $(document).find('.cc-product-detail').data('pid');
            var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
            // new analytics parameter: accessType
            if ($(this).parents('.js-sticky-add-to-cart').length) {
                var accessType = 'pdp-sticky-bottom';
            } else {
                var accessType = 'pdp';
            }
            $('#size-overlay').data('accessType', accessType);
            var analyticsOwn = 'applepay';
            $('#size-overlay').data('analyticsowner', analyticsOwn);
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Size Selector',
                eventAction: 'open',
                eventLabel: id + color,
                buttonType: analyticsOwn,
                accessType: accessType
            });
            performOpenSizeSelector(e);
        });
        $('body').on('click', '.js-fake-apple-pay.js-mobile', (e) => {
            var id = $(document).find('.cc-product-detail').data('pid');
            var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
            var analyticsOwn = 'applepay';
            $('#size-overlay').data('analyticsowner', analyticsOwn);
            // new analytics parameter: accessType
            var accessType = 'pdp-sticky-bottom';
            $('#size-overlay').data('accessType', accessType);
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Size Selector',
                eventAction: 'open',
                eventLabel: id + color,
                buttonType: analyticsOwn,
                accessType: accessType
            });
            // open size modal sticky
            const modalTarget = $('.js-size-sticky').data('target');
            $('.js-size-sticky').toggleClass('cc-open');
            $(modalTarget).toggleClass('cc-open');
            e.stopPropagation();
        });
        $('.js-analytics-close-selectsize').on('click', function(e) {
            var id = $(document).find('.cc-product-detail').data('skumaster');
            var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
            var analyticsOwn = $('#size-overlay').data('analyticsowner');
            var accessType = $('#size-overlay').data('accessType');
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Size Selector',
                eventAction: 'close',
                eventLabel: id + color,
                buttonType: analyticsOwn,
                accessType: accessType
            });
            $('#size-overlay').removeData('analyticsowner');
            $('#size-overlay').removeData('accessType');
        });
    },

    openSizeSelectorFromRequestSize: function () {
        let modalTarget = $('.js-open-choice').data('target');
        let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
        $('body').on('click', '.js-back-selectsize', function (e) {
            if (!window.isMobile && !$('#size-modal-sticky').hasClass('js-close-requestSize')) {
                e.stopPropagation();
                modal.open();
                $('body').one('product:afterAttributeSelect', () => { modal.close(); });
                $('.js-check-availability').one('click', () => { modal.close(); });
            }
            $('#size-modal-sticky').removeClass('js-close-requestSize');
        });
    },

    openRequestSize: function () {
        $(document).on('click', '.js-check-availability', function (e) {
            var urlGetParameter = $(this).data('parameter');
            var strokeClose = $(e.currentTarget).data('strokeclose');
            var arrow = $(e.currentTarget).data('arrowback');
            var size = $(e.currentTarget).data('size');
            var ecomSize = this.dataset.sizehtml;
            var sku = $(document).find('.cc-product-detail').data('pid');
            var color = $(document).find('.js-color-choice.cc-active').data('attr-value');
            var target = this.dataset.target;
            var overlay;
            if (window.isMobile) {
                target = target + '-mob';
                overlay = '#js-requestSize-product-overlay-mob';
            } else {
                target = target + '-desk';
                overlay = '#js-requestSize-product-overlay-desk';
            }
            let m = new Modal(target, { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
            var $stickyModal = $(this).closest('.cc-size-choice-overlay-sticky');
            if ($stickyModal.length > 0) {
                $stickyModal.removeClass('cc-open');
                $stickyModal.siblings('.cc-size-choice-button-sticky.js-size-sticky.js-sticky-choice').removeClass('cc-open');
            }
            $.spinner().start();
            $.ajax({
                url: urlGetParameter,
                method: 'POST',
                data: {
                    size: size,
                    ecomSize: ecomSize,
                    sku: sku,
                    color: color
                },
                success: function (data) {
                    $(overlay).html(data);
                    $.spinner().stop();
                    setButtonAttribute();
                    m.open();
                    if (window.isMobile) {
                        $('.cc-requestsize-only-mobile .js-change-icon').attr('xlink:href', strokeClose);
                    }
                    $('#request-size-overlay-desk .js-back-selectsize').one('click', () => {
                        m.close();
                        $('.js-back-selectsize').children().attr('xlink:href', arrow);
                    });
                    $('#request-size-overlay-mob .js-back-selectsize').one('click', () => {
                        $(m.modal).removeClass('cc-open');
                        $(m.modal).addClass('hidden').attr('aria-hidden', 'true');
                        m._open = false;
                        m._previouslyFocussedElement.focus();
                        if (m._config.onClose) {
                            m._config.onClose();
                        }
                        $('body').removeClass('cc-blocked');
                        document.removeEventListener('keydown', this._onKeyDown);
                    });
                    $('button[data-id="request-size-title"]').attr({
                        'aria-required': 'true',
                        'aria-describedby': 'form-selecttitle-error'
                    });
                }
            });
        });
    },

    submitRequestSize: function () {
        $(document).on('click', '.js-requestsize-button', function () {
            var url = $('.js-requestsize-button').data('action');
            var form = $($('.js-form-control-requestsize')[0]);
            var size = form.find('.js-requestsize-size :selected').text().trim();
            var productID = $('.js-product-id').val().trim() + $('.js-color-selected').val().trim();
            var label = productID + ' - ' + size;
            form.find('[name=ecomSize]').val(size);
            var checkHoneyPot = $('.contact_me_if_spam').val();
            var isSpam = checkHoneyPot.length > 0;
            if (!isSpam) {
                form.spinner().start();
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: form.serialize(),
                    success: function (data) {
                        form.spinner().stop();
                        $('.js-form-control-requestsize').fadeOut();
                        $('.js-success-page-requestSize').fadeIn();
                        uploadSuccesPage($('.js-success-page-requestSize'), data);
                        // analytics
                        if (data.response.success === true) {
                            dataLayer.push({
                                event: 'requestSize',
                                eventCategory: 'Request Size',
                                eventAction: 'submit_ok',
                                eventLabel: label
                            });
                        } else {
                            dataLayer.push({
                                event: 'requestSize',
                                eventCategory: 'Request Size',
                                eventAction: 'submit_fail',
                                eventLabel: label
                            });
                        }
                        // END
                    },
                    error: function (data) {
                        // analytics
                        dataLayer.push({
                            event: 'requestSize',
                            eventCategory: 'Request Size',
                            eventAction: 'submit_fail',
                            eventLabel: label
                        });
                        // END
                        form.spinner().stop();
                        $('.js-form-control-requestsize').fadeOut();
                        $('.js-success-page-requestSize').fadeIn();
                        uploadSuccesPage($('.js-success-page-requestSize'), data);
                    }
                });
            }
        });
    },
    /*
    allFildFullrequestsizeForm: function () {
        $(document).ready(function () {
            allFildeRequestSize();
        });
        $(document).on('change', '.js-form-control-requestsize', function () {
            allFildeRequestSize();
        });
    },
    */
    // closeRequestSize: function () {
    //     $(document).on('click', '.cc-mobile .js-back-selectsize', function (e) {
    //         $('.js-requestSize').fadeOut();
    //         $('body').removeClass('cc-blocked').removeClass('cc-blocked');
    //         liveChatEnable();
    //         var loggedCustomerEmail = $('.js-requestsize-email').data('islogged');
    //         var islogged = (loggedCustomerEmail !== null && loggedCustomerEmail !== 'undefined');
    //         if (!islogged) {
    //             clearForm($('.js-form-control-requestsize'));
    //         }
    //         uploadFormRequestSize();
    //     });
    // },

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');
            if ($productContainer.length === 0) {
                $productContainer = $('.product-detail[data-pid="' + $('#idNumberSizeSelectedUrl').val() + '"]');
            }
            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);
            // update request size modal after select product variation
            $productContainer.find('.js-productVariation-update')
                .empty()
                .html(data.requestSizeHtml);
            $('.cc-select.js-requestsize-size').selectpicker();
            $('.cc-select.js-requestsize-title').selectpicker();

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },

    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            $('.product-detail').data('pid', response.data.product.id);
            $('.js-open-contact').data('sku', response.data.product.sku);
            var skuWColor = response.data.product.skuMaster;
            var colorAttr = response.data.product.variationAttributes[0].values;
            for (var i = 0; i < colorAttr.length; i++) {
                if (colorAttr[i].selected) {
                    skuWColor += colorAttr[i].id;
                }
            }
            $('.js-find-in-store-button').attr('data-sku', skuWColor);
            $('.js-open-choice').toArray().forEach(closeModal);
            $('.js-sticky-choice').toArray().forEach(closeModal);
            // Close open modals
            if (openFromBuyButton) {
                base.performAddToCart(this);
            }
            if ($('#4giftButtonSizeNotSelected').val() === 'true') {
                $('body').trigger('product:afterAttributeSelect4gift');
            }

            // trigger wishlist update
            $('body').trigger('wishlist:productVariantChanged');

            if ($('.js-recommendationTemplate:not(.js-do-not-load)').length) {
                var url = $('#urlRecommendations').val();
                var queryString = window.location.search;
                var queryPid = '&pid=';
                if (queryString == '') {
                    queryPid = '?pid=';
                }
                var completeUrl = url + queryString + queryPid + skuWColor;

                $.ajax({
                    url: completeUrl,
                    method: 'GET',
                    success: function (data) {
                        if (data) {
                            $('.js-recommendationTemplate').html(data);
                            $('.js-product-recommendations').removeClass('d-none');
                            recommendationSlider();
                            removeWishlistinRecommendation();

                            document.querySelectorAll('iframe.lazyload').forEach(video => {
                                let endPoint = $(video).eq(0).attr('data-video-url');
                                if (!endPoint) {
                                    return;
                                }
                                $.ajax({
                                    url: endPoint,
                                    method: 'GET',
                                    success: function(data) {
                                        $(video).attr('src', data.videoURL);
                                    },
                                    error: function (err) {
                                        console.log(err);
                                    }
                                });
                            });
                        }
                    },
                    error: function(err) {
                    }
                });
            }
        });
    },

    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).data('disabled',
                (!response.product.readyToOrder || !response.product.available));
            manageApplePayButtonApperance(response);
        });
    },

    sizeChart: function () {
        $('body').on('click', '.js-open-size-chart', function (e) {
            e.preventDefault();
            var buttonPressed = $(this);
            var url = buttonPressed.data('href');
            var buttonID = this.id;
            $(document).find('.cc-size-chart-overlay-container').css('content-visibility', 'visible');
            if (buttonID === 'size-chart-stiky' && !window.isMobile) {
                $('#js-open-from-sticky').val(true);
            } else {
                $('#js-open-from-sticky').val(false);
            }
            var $prodSizeChart;
            var modalTarget;
            if (window.isMobile) {
                $prodSizeChart = $('#js-size-chart-content-mobile');
                modalTarget = buttonPressed.data('target-mobile');
            } else {
                $prodSizeChart = $('#js-size-chart-content');
                modalTarget = buttonPressed.data('target');
            }
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'text',
                    success: function (data) {
                        // analytics
                        dataLayer.push({
                            event: 'sizeChart',
                            eventCategory: 'Size Chart',
                            eventAction: 'open'
                        });
                        // END
                        $prodSizeChart.html(data);
                        if (window.isMobile) {
                            $('.js-open-choice').toArray().forEach(closeModal);
                        }
                        e.stopPropagation();

                        var modal = new Modal(modalTarget, { onShow: openSizeChartModal, onClose: closeSizeChartModal });
                        modal.open();
                    }
                });
            } else {
                var modal = new Modal(modalTarget, { onShow: openSizeChartModal, onClose: closeSizeChartModal });
                modal.open();
            }
        });
    },

    updateLinksWithTemplate: function () {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('template')) {
            var template = urlParams.get('template');
            $('.js-update-with-template').each((_idx, el) => {
                var currentLink = $(el).attr('href');
                let updatedLink = replaceOrAddQueryParam(currentLink, 'template', template);
                $(el).attr('href', updatedLink);
            });
        }
    },

    closeSizeChart: function () {
        $(document).on('click', '.js-close-size-chart', function () {
            var sizeChartOverlayId;
            var sizeOverlay;
            var openedFromSticky = $('#js-open-from-sticky').val();
            if (window.isMobile) {
                sizeChartOverlayId = '#size-chart-overlay-mobile';
                sizeOverlay = '#size-modal-sticky';
            } else {
                sizeChartOverlayId = '#size-chart-overlay';
                sizeOverlay = '#size-overlay';
            }

            if (!window.mobile) {
                var modal = new Modal(sizeOverlay, { onShow: openSizeChartModal, onClose: closeSizeChartModal });
                modal.close();
            } else {
                var modal = new Modal(sizeOverlay, { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
                modal.open();
                $('.cc-product-detail .cc-info-section').removeAttr('style');
            }
        });
    },

    sizeChartMeasure: function () {
        $('body').on('click', '.js-size-measure-selector', function (e) {
            e.preventDefault();
            var measureSelected = $(this);
            var tableSelectedId = measureSelected.data('table-id');

            var oldSelected = measureSelected.parent('.js-cc-udm').siblings();
            oldSelected.removeClass('cc-active');
            var oldTableID = oldSelected.find('.js-size-measure-selector').data('table-id');
            $('#' + oldTableID).hide();
            measureSelected.parent('.js-cc-udm').addClass('cc-active');
            $('#' + tableSelectedId).show();
        });
    },

    setNumberPageCarouselReccomandation: function() {
        $('.cc-product-recommendations .cc-slider').on('setPosition', function(event, slick) {
            var slideTosho = $('.cc-product-recommendations .cc-slider').data('items-row');
            if ($(window).width() < 1439.98) slideTosho = 3;
            if ($(window).width() < 767.98) slideTosho = 1;
            var currentSlide = slick.currentSlide + 1;
            var totalSlide = slick.slideCount - (slideTosho - 1);
            var arialabelPrev;
            if (currentSlide <= totalSlide && (currentSlide - 1) > 0) {
                arialabelPrev = $('.cc-product-list.cc-slider').data('arialabelprev').replace('{0}', currentSlide - 1).replace('{1}', totalSlide);
            } else {
                arialabelPrev = $('.cc-product-list.cc-slider').data('arialabelprev').replace('{0}', currentSlide).replace('{1}', totalSlide);
            }
            var arialabelNext;
            if ((currentSlide + 1) <= totalSlide) {
                arialabelNext = $('.cc-product-list.cc-slider').data('arialabelnext').replace('{0}', currentSlide + 1).replace('{1}', totalSlide);
            } else {
                arialabelNext = $('.cc-product-list.cc-slider').data('arialabelnext').replace('{0}', currentSlide).replace('{1}', totalSlide);
            }
            $('.cc-product-recommendations .cc-slider-prev').attr('aria-label', arialabelPrev);
            $('.cc-product-recommendations .cc-slider-next').attr('aria-label', arialabelNext);
            // set tabindex -1 if product isn't show, and 0 if is show
            $('.slick-slide').each(function() {
                $(this).attr('aria-hidden') === 'true' ? $(this).attr('tabindex', '-1') : $(this).attr('tabindex', '0');
            });
        });
    },

    shippingPackaging: function () {
        $(document).on('click', '.js-packaging-iteam', function () {
            if ($(this).hasClass('active')) {
                $(this).find('span').removeClass('cc-noActive');
                $(this).parent().siblings().children().find('span').addClass('cc-noActive');
            }
            var $menu = $(this).closest('.cc-packaging-shipping-list');
            if ($('body').hasClass('cc-mobile') || ($('body').hasClass('cc-tablet') && $(this).closest('.cc-content-packaging-shipping-list-four').length > 0)) {
                var myScrollPos = $(this).offset().left + ($(this).outerWidth(true) / 2) + $menu.scrollLeft() - $menu.width() / 2;
                $menu.scrollLeft(myScrollPos);
            }
        });
    },

    initializeSize: function() {
        $(document).ready(function() {
            autoSelectForOneSize();
        });
    },

    setIdForModalDialogattributes: function() {
        $(document).ready(function() {
            // set dialog id selectsticky
            var ariaDescribedBy = $(document).find('.cc-size-choice-overlay-sticky').attr('aria-describedby');
            var ariaLabelledby = $(document).find('.cc-size-choice-overlay-sticky').attr('aria-labelledby');
            $(document).find('.cc-size-choice-overlay-sticky .cc-head-title').attr('id', ariaLabelledby);
            $(document).find('.cc-size-choice-overlay-sticky .js-change-for-stiky').attr('id', ariaDescribedBy);
            // set dialog id whishlistMesage
            var $wishListMessage = $(document).find('.cc-info-container .cc-mobile-only .cc-add-to-wishlist-message');
            var ariaDescribedByWish = $wishListMessage.attr('aria-describedby');
            var newAriaDescribedByWish = ariaDescribedByWish + '-Mobile';
            var ariaLabelledbyWish = $wishListMessage.attr('aria-labelledby');
            var newAriaLabelledbyWish = ariaLabelledbyWish + '-Mobile';
            $(document).find('.cc-info-container .cc-mobile-only .cc-add-to-wishlist-message .cc-prod-title').attr('id', newAriaLabelledbyWish);
            $(document).find('.cc-info-container .cc-mobile-only .cc-add-to-wishlist-message .js-wish-changeId-forMobile').attr('id', newAriaDescribedByWish);
            $wishListMessage.attr('aria-describedby', newAriaDescribedByWish);
            $wishListMessage.attr('aria-labelledby', newAriaLabelledbyWish);
            // set id for butto selectsize stiky
            $(document).find('.cc-size-choice-overlay-sticky .js-open-size-chart').attr('id', 'size-chart-stiky');
            $(document).find('.cc-size-choice-overlay-sticky .js-open-helpWhitSize').attr('id', 'size-help-sticky');
        });
    },

    copyProductLink: function (e) {
        $(document).on('click keydown', '.js-share-product-link', function (event) {
            if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ')  return;
            var copyText = $(this).data('url');
            navigator.clipboard.writeText(copyText);
            var copiedLink = $(this).find('.js-link-label').data('copied');
            $(this).find('.js-link-label').find('.js-social-text').text(copiedLink);
        });
    },

    loadRecommendations: function () {
        $(document).ready(function () {
            if ($('.js-recommendationTemplate:not(.js-do-not-load)').length) {
                if ($('.cc-product-detail--shop-look').length === 0) {
                    var url = $('#urlRecommendations').val();
                    var pid = $('.product-detail').data('pid');
                    var queryString = window.location.search;
                    var queryPid = '&pid=';
                    if (queryString == '') {
                        queryPid = '?pid=';
                    }
                    var completeUrl = url + queryString + queryPid + pid;
                    $.ajax({
                        url: completeUrl,
                        method: 'GET',
                        success: function (data) {
                            if (data) {
                                $('.js-recommendationTemplate').html(data);
                                $('.js-product-recommendations').removeClass('d-none');
                                recommendationSlider();
                                removeWishlistinRecommendation();

                                document.querySelectorAll('iframe.lazyload').forEach(video => {
                                    let endPoint = $(video).eq(0).attr('data-video-url');
                                    if (!endPoint) {
                                        return;
                                    }
                                    $.ajax({
                                        url: endPoint,
                                        method: 'GET',
                                        success: function(data) {
                                            $(video).attr('src', data.videoURL);
                                        },
                                        error: function (err) {
                                        }
                                    });
                                });
                            }
                        },
                        error: function(err) {
                        }
                    });
                }
            }
        });
    },

    addToCartAutomatic: function() {
        $(document).ready(function () {
            var addToCartAutomatic = $('#addToCartAutomatic').val();
            if (addToCartAutomatic === 'true') {
                if (window.isMobile) {
                    if (!$($('button.add-to-cart')[1]).data('disabled')) {
                        $($('button.add-to-cart')[1]).click();
                    }
                } else {
                    if (!$($('button.add-to-cart')[0]).data('disabled')) {
                        $($('button.add-to-cart')[0]).click();
                    }
                }
            }
        });
    },

    fixSelectDropdowns: function() {
        // accessibility: fix dropdowns select focus issues
        $(document).ready(function() {
            // fix dropdowns not focusable
            $(document).on('keydown.fixdropdown', (e)=>{
                if (e.key === 'Tab'){
                    $('.dropdown-toggle').attr('tabindex', '0');
                }
            });

            $(document).on('keydown.fixdropdown', '.dropdown:not(.show) .dropdown-toggle', function(e){
                if (e.key === 'Enter' || e.key === ' ') {
                    // trigger click and move focus to dropdown items
                    $(this)[0].click();
                    var $menu = $(this).siblings('.dropdown-menu');
                    $menu.find('.dropdown-item')[0].focus();
                }
            });

            $(document).on('keydown.fixdropdown', '.dropdown-item', function(e){
                if (e.key === 'Enter' || e.key === ' ') {
                    $(this)[0].click();
                }
            });
        });
    }
};
